import React from 'react';
import { TAGS, TEXT } from '../../../../../content';
import { PATH } from '../../../../../constants';
import { MsgCountContext } from '../../../../../context';
import CategoryItems from './CategoryItems/CategoryItems';
import './CategoryList.css';

const CategoryList = props => {
  const { match } = props;
  const categoryId = match.params.id;

  const categoryName = TAGS[categoryId];
  const existingCategory = categoryName !== undefined;

  return (
    <div id="category-list">
      {existingCategory && (
        <React.Fragment>
          <div id="category-title">
            <img
              id="category-name"
              src={`${PATH.IMG}title/${categoryId}.png`}
              alt={categoryName}
            />
          </div>
          <MsgCountContext.Consumer>
            {msgCount => (
              <CategoryItems categoryId={categoryId} msgCount={msgCount} />
            )}
          </MsgCountContext.Consumer>
        </React.Fragment>
      )}
      {!existingCategory && <h2>{TEXT.EMPTY_CATEGORY}</h2>}
    </div>
  );
};

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/CategoryList/CategoryList.js